var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex" },
    [
      _c(
        "div",
        { staticClass: "flex-shrink-0", style: { paddingRight: "37.5rem" } },
        [
          _c(
            "div",
            {
              staticClass:
                "sticky left-0 z-30 flex items-center justify-between px-6 h-14 top-24 bg-slate-300",
              style: { width: "calc(100vw - 37.5rem - 0.5rem)" }
            },
            [
              _c(
                "div",
                [
                  _c("BlTextBody2", {
                    attrs: {
                      text:
                        "Showing " +
                        _vm.bookingTimeslots.length +
                        " appointment schedule(s)"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex items-center gap-2" },
                [
                  _c(
                    "div",
                    [
                      _c("BlSelectBox", {
                        attrs: { options: _vm.timeslotViewOptions, dense: "" },
                        on: {
                          change: function($event) {
                            return _vm.$emit("set-timeslot-view", $event)
                          }
                        },
                        model: {
                          value: _vm.timeslotView,
                          callback: function($$v) {
                            _vm.timeslotView = $$v
                          },
                          expression: "timeslotView"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "h-7.5 w-72 flex items-center justify-center bg-pure-white hover:bg-slate-400 rounded border border-slate-400 transition-all duration-300 cursor-pointer"
                    },
                    [
                      _c("BlTextBody2", { attrs: { text: _vm.masterDate } }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.dateInput,
                            expression: "dateInput"
                          }
                        ],
                        staticClass:
                          "absolute opacity-0 bl-input-full-indicator w-72 ",
                        attrs: {
                          type: "date",
                          min: _vm.minimumDate,
                          max: _vm.maximumDate
                        },
                        domProps: { value: _vm.dateInput },
                        on: {
                          change: function($event) {
                            return _vm.onDateInput($event.target.value)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.dateInput = $event.target.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("BlInputButton", {
                    staticClass: "rounded-full",
                    attrs: {
                      type: "outlined",
                      dense: "",
                      icon: "chevron-left",
                      disabled: _vm.isDateBackDisabled
                    },
                    on: {
                      clicked: function($event) {
                        return _vm.onNextDate(-7)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("BlInputButton", {
                    staticClass: "rounded-full",
                    attrs: {
                      type: "outlined",
                      dense: "",
                      icon: "chevron-right",
                      disabled: _vm.isDateNextDisabled
                    },
                    on: {
                      clicked: function($event) {
                        return _vm.onNextDate(7)
                      }
                    }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "sticky z-20 flex h-12 top-38 bg-slate-200" },
            [
              _c("div", {
                staticClass:
                  "sticky left-0 z-10 flex-shrink-0 w-20 h-12 border-b bg-slate-200 border-slate-400"
              }),
              _vm._v(" "),
              _vm._l(_vm.headers, function(n, idx) {
                return _c(
                  "div",
                  {
                    key: idx,
                    staticClass:
                      "flex items-center justify-center flex-shrink-0 h-12 px-2 py-1 border-b border-slate-400",
                    style: { width: "calc(" + _vm.slotWidth + ")" }
                  },
                  [
                    n.highlight
                      ? _c(
                          "div",
                          { staticClass: "flex items-center gap-1 h-7" },
                          [
                            _c("BlTextBody2", {
                              attrs: { text: n.label.split(" ")[0] }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex items-center justify-center rounded-full h-7 w-7 bg-light-purple-400"
                              },
                              [
                                _c("BlTextBody2", {
                                  staticClass: "text-pure-white",
                                  attrs: { text: n.label.split(" ").pop() }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _c(
                          "div",
                          {
                            staticClass: "px-4 truncate h-7",
                            attrs: { title: n.label }
                          },
                          [
                            _c("BlTextBody2", {
                              staticClass: "truncate",
                              attrs: { text: n.label }
                            })
                          ],
                          1
                        )
                  ]
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "relative flex flex-col bg-slate-200" },
            _vm._l(_vm.clockRound, function(time) {
              return _c(
                "div",
                {
                  key: time,
                  staticClass: "flex",
                  attrs: { id: "recurring_time_view_" + time }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "sticky left-0 z-10 flex justify-end flex-shrink-0 w-20 px-3 py-2 transition-all duration-300 border-b border-r bg-slate-200 border-slate-400",
                      style: { height: _vm.slotHeight * 2 + "rem" }
                    },
                    [_c("BlTextBody2", { attrs: { text: time } })],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.headers, function(n, idx) {
                    return _c("div", {
                      key: idx,
                      staticClass:
                        "flex flex-col items-center justify-center flex-shrink-0 gap-2 transition-all duration-300 border-b border-r border-slate-400",
                      class: [
                        _vm.onCheckUsedBlock(n.value)
                          ? "bg-slate-200"
                          : "bg-slate-300"
                      ],
                      style: {
                        height: _vm.slotHeight * 2 + "rem",
                        width: "calc(" + _vm.slotWidth + ")"
                      }
                    })
                  })
                ],
                2
              )
            }),
            0
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "fixed z-50 flex-shrink-0 overflow-y-auto border top-24 right-2 bg-pure-white border-slate-400 scrollbar-lg",
          style: {
            height: "calc(100vh - 6rem - 5rem - 0.5rem)",
            width: "37.5rem"
          }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "sticky top-0 z-10 flex flex-col gap-3 px-6 py-4 border-b bg-pure-white border-slate-400"
            },
            [
              _c("BlTextSubtitle1", {
                attrs: { text: "Review and confirm appointments" }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "flex items-center h-16 gap-4" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "flex flex-col items-center justify-between w-full h-16 gap-1"
                  },
                  [
                    _c("BlTextTitle3", {
                      staticClass: "text-slate-800",
                      attrs: { text: _vm.bookingTimeslots.length }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody2", { attrs: { text: "Total appointments" } })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", {
                  staticClass: "h-16 w-0.5 flex-shrink-0 bg-slate-300"
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "flex flex-col items-center justify-between w-full h-16 gap-1"
                  },
                  [
                    _c("BlTextTitle3", {
                      class: [
                        _vm.hasConflict ? "text-tomato-700" : "text-slate-500"
                      ],
                      attrs: { text: _vm.totalConflictTimeslots }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      attrs: { text: "Conflicting appointments" }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "flex flex-col gap-3 px-6 py-4" }, [
            _c(
              "div",
              {
                staticClass: "flex flex-col gap-2 px-4 py-4 rounded",
                class: [_vm.minusCredit ? "bg-tomato-100" : "bg-cornflower-200"]
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "flex items-center justify-between cursor-pointer",
                    on: {
                      click: function($event) {
                        _vm.calculationOpened = !_vm.calculationOpened
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex items-center gap-2" },
                      [
                        _c("BlIcon", {
                          staticClass: "w-6 h-6",
                          attrs: {
                            icon: "piggy",
                            color: _vm.minusCredit ? "tomato-7" : "cornflower-8"
                          }
                        }),
                        _vm._v(" "),
                        _c("BlTextSubtitle3", {
                          class: [
                            _vm.minusCredit
                              ? "text-tomato-700"
                              : "text-cornflower-800"
                          ],
                          attrs: { text: "Credits calculation" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("BlIcon", {
                      staticClass: "w-6 transition-all duration-300",
                      style: {
                        rotate: _vm.calculationOpened ? "0deg" : "180deg"
                      },
                      attrs: {
                        icon: "chevron-up",
                        color: _vm.minusCredit ? "tomato-7" : "cornflower-8",
                        clickable: ""
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.calculationOpened
                  ? _c(
                      "div",
                      { staticClass: "flex flex-col gap-2" },
                      _vm._l(_vm.usedPackageItemServices, function(used) {
                        return _c(
                          "div",
                          { key: used.id, staticClass: "flex flex-col gap-1" },
                          [
                            _c("BlTextSubtitle3", {
                              class: [
                                used.projected_remaining_credits < 0
                                  ? "text-tomato-700"
                                  : "text-cornflower-800"
                              ],
                              attrs: { text: used.package_item_name }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex items-center justify-between gap-2"
                              },
                              [
                                _c("BlTextBody2", {
                                  class: [
                                    used.projected_remaining_credits < 0
                                      ? "text-tomato-700"
                                      : "text-cornflower-800"
                                  ],
                                  attrs: {
                                    text:
                                      "Credits used for " +
                                      used.total_appointments +
                                      " appointment(s)"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "rounded h-5.5 w-11 flex items-center justify-center",
                                    class: [
                                      used.projected_remaining_credits < 0
                                        ? "bg-tomato-700"
                                        : "bg-cornflower-800"
                                    ]
                                  },
                                  [
                                    _c("BlTextSubtitle3", {
                                      class: [
                                        used.projected_remaining_credits < 0
                                          ? "text-tomato-100"
                                          : "text-cornflower-200"
                                      ],
                                      attrs: { text: used.total_used_credits }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex items-center justify-between gap-2"
                              },
                              [
                                _c("BlTextBody2", {
                                  class: [
                                    used.projected_remaining_credits < 0
                                      ? "text-tomato-700"
                                      : "text-cornflower-800"
                                  ],
                                  attrs: {
                                    text:
                                      "Projected remaining credits after " +
                                      used.total_appointments +
                                      " session(s) is completed"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "rounded h-5.5 w-11 flex items-center justify-center",
                                    class: [
                                      used.projected_remaining_credits < 0
                                        ? "bg-tomato-700"
                                        : "bg-cornflower-800"
                                    ]
                                  },
                                  [
                                    _c("BlTextSubtitle3", {
                                      class: [
                                        used.projected_remaining_credits < 0
                                          ? "text-tomato-100"
                                          : "text-cornflower-200"
                                      ],
                                      attrs: {
                                        text: used.projected_remaining_credits
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _vm.minusCredit && !_vm.hasConflict
              ? _c(
                  "div",
                  [
                    _c("BlTextBody2", {
                      attrs: {
                        text:
                          "The projected remaining credits are negative due to exceeding the appointment limit. Please adjust the duration of each appointment to ensure the projected remaining credits reach zero, or delete some of the appointments."
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.minusCredit && _vm.hasConflict
              ? _c(
                  "div",
                  [
                    _c("BlTextBody2", {
                      attrs: {
                        text:
                          "The selected therapist is unavailable on one or more of the scheduled dates. Please delete the affected appointments to move forward."
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.minusCredit && _vm.hasConflict
              ? _c(
                  "div",
                  [
                    _c("BlTextBody2", {
                      attrs: {
                        text:
                          "Some appointments conflict with therapist availability, and the projected remaining credits are negative due to exceeding the appointment limit. Please delete the conflicting appointments and adjust the number of appointments to proceed."
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              _vm._l(_vm.sortedTimeslots, function(timeslot) {
                return _c("ItemTimeslot", {
                  key: timeslot.id,
                  attrs: {
                    timeslot: timeslot,
                    deleteDisabled: timeslot.status === "booking_in_progress"
                  },
                  on: {
                    delete: function($event) {
                      return _vm.$emit("delete-timeslot", $event)
                    }
                  }
                })
              }),
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.existingSlots, function(slot, idx) {
        return _c("SlotRecurring", {
          key: idx + "_" + slot.id,
          attrs: {
            isCompact: _vm.timeslotView === "compact",
            period: slot.period,
            therapist: slot.user,
            room: slot.room,
            position: slot.position,
            assets: slot.assets,
            error: slot.is_conflicted
          }
        })
      }),
      _vm._v(" "),
      _vm._l(_vm.existingAppointments, function(slot, idx) {
        return _c("SlotRecurring", {
          key: idx + "_" + slot.id,
          style: { zIndex: 1 },
          attrs: {
            isCompact: _vm.timeslotView === "compact",
            period: slot.period,
            therapist: slot.user,
            room: slot.room,
            position: slot.position,
            assets: slot.assets
          }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-69c16fe0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69c16fe0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointments/overlay/ReviewAppointmentRecurring.vue
// module id = null
// module chunks = 